import type { SVGProps } from "react";
export default function SvgExcel(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 24 23"
			{...props}
		>
			<g clipPath="url(#clip0_496_38)">
				<path fill="white" d="M23.373 2.773H9.72v17.51h13.653z" />
				<path
					fill="#1F7144"
					d="M9.199 2.247a.973.973 0 0 0-.97.98V19.77c0 .542.433.98.97.98H23.03a.973.973 0 0 0 .969-.98V3.228a.973.973 0 0 0-.969-.98zm-.195.813h14.213v16.867H9.004z"
				/>
				<path fill="#1F7144" d="M21.51 4.682h-3.827V6.78h3.827z" />
				<path fill="#1F7144" d="M16.87 4.682h-3.826V6.78h3.827z" />
				<path fill="#1F7144" d="M21.51 7.547h-3.827v2.098h3.827z" />
				<path fill="#1F7144" d="M16.87 7.537h-3.826v2.098h3.827z" />
				<path fill="#1F7144" d="M21.51 10.451h-3.827v2.098h3.827z" />
				<path fill="#1F7144" d="M16.87 10.451h-3.826v2.098h3.827z" />
				<path fill="#1F7144" d="M21.51 13.388h-3.827v2.098h3.827z" />
				<path fill="#1F7144" d="M16.87 13.37h-3.826v2.097h3.827z" />
				<path fill="#1F7144" d="M21.51 16.276h-3.827v2.097h3.827z" />
				<path fill="#1F7144" d="M16.87 16.276h-3.826v2.097h3.827z" />
				<path fill="#1D6B40" d="M13.654 23V0L0 2.3v18.4z" />
				<path
					fill="white"
					d="m5.343 7.657.945 2.494c.068.148.1.306.115.412-.008-.124.018-.22.088-.412L7.61 7.52l1.721-.104a115 115 0 0 0-2.01 4.084l2.096 4.201-1.855-.112-1.128-2.741c-.088-.207-.07-.235-.089-.336-.008.072-.01.131-.058.261l-1.134 2.671-1.592-.096 1.84-3.792-1.656-3.803z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_496_38">
					<rect width={24} height={23} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
